// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'Collapse Item, Deleted': 'تم حذف كولابس بنجاح',
};
